import { render } from "./Villages.vue?vue&type=template&id=39e73324"
import script from "./Villages.vue?vue&type=script&lang=js"
export * from "./Villages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/player/Villages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39e73324"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39e73324', __exports__)) {
    api.reload('39e73324', __exports__)
  }
  
  module.hot.accept("./Villages.vue?vue&type=template&id=39e73324", () => {
    api.rerender('39e73324', render)
  })

}


export default __exports__